export class EpayAnulacion {

    constructor(
        public transaccion: number
      

    ) {}
}
